import { Injectable } from '@angular/core';
import { TravelRequestEnum } from '@app/enums/travel-request.enum';
import { TravelRequest } from '@models/request';
import { AdminRequestRepository } from '@repositories/admin/admin-request.repository';
import { MdsOptionGeneric } from '@utility/utility';
import { Observable } from 'rxjs';
import { StateService } from './state.service';

@Injectable({
    providedIn: 'root',
})
export class TravelRequestStateService extends StateService<TravelRequest> {
    constructor(private requestRepository: AdminRequestRepository) {
        super();
    }
    public override get(id: number): Observable<TravelRequest> {
        return this.requestRepository.getTravelRequest(id);
    }
    readonly receiptTypeOption_Flight: MdsOptionGeneric<TravelRequestEnum> = {
        value: TravelRequestEnum.flight,
        viewValue: 'Airfare',
    };
    readonly receiptTypeOption_Train: MdsOptionGeneric<TravelRequestEnum> = {
        value: TravelRequestEnum.train,
        viewValue: 'Train',
    };
    readonly receiptTypeOption_Lodging: MdsOptionGeneric<TravelRequestEnum> = {
        value: TravelRequestEnum.lodging,
        viewValue: 'Lodging',
    };
    readonly receiptTypeOption_RentalCar: MdsOptionGeneric<TravelRequestEnum> = {
        value: TravelRequestEnum.rentalCar,
        viewValue: 'Rental Car',
    };

    readonly receiptTypeOption_CarService: MdsOptionGeneric<TravelRequestEnum> = {
        value: TravelRequestEnum.carService,
        viewValue: 'Car Service',
    };
    readonly receiptTypeOption_Other: MdsOptionGeneric<TravelRequestEnum> = {
        value: TravelRequestEnum.other,
        viewValue: 'Other',
    };

    readonly receiptTypeOptions: MdsOptionGeneric<TravelRequestEnum>[] = [
        this.receiptTypeOption_Flight,
        this.receiptTypeOption_Train,
        this.receiptTypeOption_Lodging,
        this.receiptTypeOption_RentalCar,
        this.receiptTypeOption_CarService,
        this.receiptTypeOption_Other,
    ];
}
